import React from "react";
import PropTypes from "prop-types";

const LogSummary = (props) => {
  const logs = props.logs;
  const totalDistance = logs
    .map((l) => l.distance)
    .reduce((sum, current) => sum + current, 0);
  const totalLogs = logs.length;

  return (
    <React.Fragment>
      {logs.length ? (
        <p>
          {totalLogs} log(s), total distance {" "}
          {totalDistance}
        </p>
      ) : null}
    </React.Fragment>
  );
};

LogSummary.propTypes = {
  logs: PropTypes.array,
};

export default LogSummary;
